import type { StripeProductWithMetadata } from "../../../../app/api/subscription/prices/route"
import type { DefaultProduct, SubscriptionPlan } from "./useSubscriptionCheckoutModal"

export const attachStripePriceDataToPlans = (
  plans: DefaultProduct[],
  stripePlansWithMetadata: StripeProductWithMetadata[]
): SubscriptionPlan[] => {
  const monthlyPlan = stripePlansWithMetadata.find(p => p.productType === "monthly")
  const monthlyPlanYearlyCost = monthlyPlan?.priceData.unit_amount && monthlyPlan.priceData.unit_amount * 12

  return plans
    .map(plan => {
      const matched = stripePlansWithMetadata.find(p => p.productType === plan.productType)

      if (!matched) {
        console.warn(`No Stripe price data found for plan: ${plan.name}`)
        return null
      }

      const price = matched.priceData.unit_amount
      const interval = matched.priceData.recurring?.interval

      let priceDisplay: string | undefined = undefined
      let yearlySavings: number | null = null

      if (price) {
        priceDisplay = `$${(price / 100).toFixed(2)}`
        if (interval === "year") {
          priceDisplay += "/yr"
          if (monthlyPlanYearlyCost) {
            yearlySavings = (monthlyPlanYearlyCost - price) / 100
          }
        } else if (interval === "month") {
          priceDisplay += "/mo"
        }
      }

      return {
        ...plan,
        priceDisplay,
        yearlySavings,
        stripeData: matched.priceData,
        priceId: matched.priceId,
      }
    })
    .filter((p): p is NonNullable<typeof p> => p !== null) as SubscriptionPlan[]
}
